const type = 'SET_MODAL_OUTCOME';

const setModalOutcome = (data) => ({
  data,
  type,
});

export { type };
export default setModalOutcome;
